export const SLIDE_WIDTH = 900;

export const SLIDE_HEIGHT = 1200;
